module.exports = __webpack_public_path__ + "static/img/scene6.813342a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene/scene6.png
// module id = jT5d
// module chunks = 1